window.JRS = window.JRS || {};

(function(JRS) {
  'use strict';

  var EventBus = JRS.EventBus;
  var CartAPI = JRS.CartAPI;
  var CartValidator = JRS.CartValidator;
  var CartPage = JRS.CartPage;
  var CartEditFlow = JRS.CartEditFlow;

  var _initialized = false;
  var _validationRun = false;
  var _boundListeners = [];
  var _debugEnabled = true;
  var _appliedValidationRefresh = false;

  function _debugLog() {
    if (!_debugEnabled || typeof console === 'undefined' || typeof console.log !== 'function') return;
    var themeId = String(window._bcThemeId || window._mrkThemeId || 'base');
    var themeVersion = String(window._bcThemeVersion || window._mrkThemeVersion || 'JRSBASE-V8.3.0-09102026-BYOB');
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[base v' + themeVersion.replace(/^\d+-/, '') + '][betterconversions][' + themeId + '][' + themeVersion + '][JRS CartController]');
    console.log.apply(console, args);
  }

  /**
   * Initialize all cart page modules.
   * Safe to call multiple times.
   *
   * @returns {void}
   */
  function init() {
    if (_initialized) return;

    var cartContainer = document.querySelector('[data-jrs-cart-page]');
    var isCartPath = typeof window !== 'undefined' && window.location && String(window.location.pathname || '').indexOf('/cart') === 0;
    _debugLog('init attempt', {
      pathname: window.location && window.location.pathname,
      hasCartContainer: !!cartContainer,
      isCartPath: !!isCartPath
    });
    if (!cartContainer && !isCartPath) return;

    _initialized = true;

    var cartData = null;
    var cartDataEl = cartContainer ? cartContainer.querySelector('[data-jrs-cart-json]') : document.querySelector('[data-jrs-cart-json]');
    if (cartDataEl) {
      try {
        cartData = JSON.parse(cartDataEl.textContent || '{}');
      } catch (error) {
        _debugLog('failed to parse cart JSON', error);
      }
    }
    _debugLog('cart data parsed', {
      hasCartData: !!cartData,
      itemCount: cartData && typeof cartData.item_count === 'number' ? cartData.item_count : null
    });

    if (CartPage && typeof CartPage.init === 'function') {
      CartPage.init(cartData);
    }
    if (CartEditFlow && typeof CartEditFlow.init === 'function') {
      CartEditFlow.init();
    }

    _runPageLoadValidation();
    _bindBfcacheProtection();
  }

  /**
   * Tear down all cart page modules.
   * @returns {void}
   */
  function destroy() {
    if (CartPage && typeof CartPage.destroy === 'function') {
      CartPage.destroy();
    }
    if (CartEditFlow && typeof CartEditFlow.destroy === 'function') {
      CartEditFlow.destroy();
    }

    _destroyListeners();

    _initialized = false;
    _validationRun = false;
  }

  /**
   * Run non-blocking cart validation once per load.
   * @returns {void}
   */
  function _runPageLoadValidation() {
    void CartAPI;

    if (_validationRun) return;
    _validationRun = true;

    if (!EventBus || typeof EventBus.on !== 'function') return;
    if (!CartValidator || typeof CartValidator.validateCart !== 'function') return;

    var cleanupDone = false;
    var unsubIssue = EventBus.on('validation:issueFound', function(data) {
      _debugLog('validation issue', data && data.type, data && data.details);
    });

    var unsubComplete = EventBus.on('validation:completed', function(data) {
      _debugLog(
        'Cart validation complete: ' +
          String(data && data.issuesFound || 0) +
          ' found, ' +
          String(data && data.issuesFixed || 0) +
          ' fixed, ' +
          String(data && data.duration || 0) +
          'ms'
      );

      if (data && data.issuesFixed > 0) {
        _cleanupValidationListeners(unsubIssue, unsubComplete, cleanupDone);
        cleanupDone = true;
        _refreshCartAfterValidationFix();
        return;
      }

      _cleanupValidationListeners(unsubIssue, unsubComplete, cleanupDone);
      cleanupDone = true;
    });

    CartValidator.validateCart().catch(function(error) {
      _debugLog('validation failed', error);
      _cleanupValidationListeners(unsubIssue, unsubComplete, cleanupDone);
      cleanupDone = true;
    });
  }

  /**
   * Avoid hard reload loops when validator fixes several batches.
   * Refresh cart data in-place once and let CartPage listeners update totals/UI.
   *
   * @returns {void}
   */
  function _refreshCartAfterValidationFix() {
    if (_appliedValidationRefresh) return;
    _appliedValidationRefresh = true;
    _debugLog('validation fixed issues, refreshing cart in-place');
    if (!CartAPI || typeof CartAPI.getCart !== 'function') return;

    CartAPI.getCart().then(function(cart) {
      if (EventBus && typeof EventBus.emit === 'function') {
        EventBus.emit('cart:updated', { cart: cart });
      }
      if (typeof document !== 'undefined') {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      }
    }).catch(function(error) {
      console.error('CartController: failed in-place refresh after validation fix:', error);
    });
  }

  /**
   * @param {function} unsubIssue
   * @param {function} unsubComplete
   * @param {boolean} alreadyCleaned
   * @returns {void}
   */
  function _cleanupValidationListeners(unsubIssue, unsubComplete, alreadyCleaned) {
    if (alreadyCleaned) return;
    if (typeof unsubIssue === 'function') unsubIssue();
    if (typeof unsubComplete === 'function') unsubComplete();
  }

  /**
   * Bind bfcache re-init behavior.
   * @returns {void}
   */
  function _bindBfcacheProtection() {
    _bindListener(window, 'pageshow', function(event) {
      if (event && event.persisted) {
        console.log('CartController: bfcache restore detected, re-initializing');
        _initialized = false;
        _validationRun = false;

        if (CartPage && typeof CartPage.destroy === 'function') {
          CartPage.destroy();
        }
        if (CartEditFlow && typeof CartEditFlow.destroy === 'function') {
          CartEditFlow.destroy();
        }

        init();
      }
    });
  }

  /**
   * @param {Element|Window|Document} el
   * @param {string} event
   * @param {function} handler
   * @returns {void}
   */
  function _bindListener(el, event, handler) {
    if (!el || !event || !handler) return;
    el.addEventListener(event, handler);
    _boundListeners.push({ el: el, event: event, handler: handler });
  }

  /**
   * @returns {void}
   */
  function _destroyListeners() {
    for (var i = 0; i < _boundListeners.length; i++) {
      var l = _boundListeners[i];
      if (!l || !l.el) continue;
      l.el.removeEventListener(l.event, l.handler);
    }
    _boundListeners = [];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  JRS.CartController = {
    init: init,
    destroy: destroy
  };
})(window.JRS);
